import _regeneratorRuntime from 'babel-runtime/regenerator';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Suspense } from 'react';
import { LoadScript } from '@react-google-maps/api';
import Map from '../components/map/Map';

import API, { graphqlOperation } from '@aws-amplify/api';
import PubSub from '@aws-amplify/pubsub';
import config from '../graphqlUsers/aws-exports';
import { getUsers } from '../graphqlUsers/queries';
import { withTranslation } from 'react-i18next';
import check0 from '../components/layerInfo/layers-devices/img/check0.png'; // desactivado
import check1 from '../components/layerInfo/layers-devices/img/check1.png'; // activado
import check2 from '../components/layerInfo/layers-devices/img/check2.png'; // pendiente de desactivar
import check3 from '../components/layerInfo/layers-devices/img/check3.png'; // pendiente de activar

API.configure(config);
PubSub.configure();

var userFromDataBase = {};
var createProfile = false;

var profiles = '';
var value = '';

var jsonGroups = "";
var jsonInfo = "";
var jsonIOInfo = "";

var getProfiles = function (_Component) {
    _inherits(getProfiles, _Component);

    function getProfiles(props) {
        var _this2 = this;

        _classCallCheck(this, getProfiles);

        var _this = _possibleConstructorReturn(this, (getProfiles.__proto__ || Object.getPrototypeOf(getProfiles)).call(this, props));

        _this.getProfile = function () {

            var newArray = [];
            userFromDataBase.userData.data.getUsers.mapOptions.map(function (user, i) {
                var now = new Date();
                newArray.push({
                    id: now.getTime() + i,
                    title: JSON.parse(user).title,
                    edit: false,
                    delete: false,
                    options: {
                        mapTypeId: JSON.parse(user).mapType,
                        gestureHandling: JSON.parse(user).gestureHandling,
                        disableDefaultUI: JSON.parse(user).mapControls,
                        mapTypeControl: JSON.parse(user).mapControls,
                        zoom: parseInt(JSON.parse(user).zoom, 10)
                    },
                    center: { lat: parseFloat(JSON.parse(user).latitude), lng: parseFloat(JSON.parse(user).longitude) },
                    isTrafficLayerShown: JSON.parse(user).trafficLayer
                });
                return user;
            });

            _this.setState({
                profiles: newArray,
                value: newArray[0].title

            });
            localStorage.setItem("profiles", JSON.stringify(newArray));
            localStorage.setItem("value", JSON.stringify(newArray[0].title));
        };

        _this.goToPageErr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (_this.props.propsRouter !== undefined) {
                                _this.props.propsRouter.location.userHasAuthenticated(false);
                            }

                            _this.props.propsRouter.history.push({
                                pathname: '/ExpireKeyErr/',
                                state: {
                                    userDataInfo: ''
                                }
                            });

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.saveJsonIOInfo = function (dataToSave) {
            var dbName = '4GFlota-DDBB-Servicios';
            var storeName = 'jsonIOInfoTable';

            // Abrir o crear la base de datos
            var request = indexedDB.open(dbName, 1);

            request.onupgradeneeded = function (event) {
                var db = event.target.result;

                // Crear un almacén de objetos si aún no existe
                if (!db.objectStoreNames.contains(storeName)) {
                    db.createObjectStore(storeName);
                }
            };

            request.onsuccess = function (event) {
                var db = event.target.result;

                // Realizar operaciones en la base de datos
                // Por ejemplo, obtener datos

                // Primero, abrir una transacción de lectura/escritura
                var transaction = db.transaction([storeName], 'readwrite');
                var objectStore = transaction.objectStore(storeName);

                // Luego, eliminar todos los datos existentes en el almacén
                var clearRequest = objectStore.clear();

                clearRequest.onsuccess = function () {
                    // Después de borrar, guardar nuevos datos
                    var putRequest = objectStore.put(dataToSave, 'jsonIOInfo');

                    putRequest.onsuccess = function () {
                        //console.log('Datos guardados exitosamente en IndexedDB.');
                    };

                    putRequest.onerror = function (event) {
                        console.error('Error al intentar guardar en IndexedDB:', event.target.error);
                    };
                };

                clearRequest.onerror = function (event) {
                    console.error('Error al intentar borrar datos en IndexedDB:', event.target.error);
                };
            };

            request.onerror = function (event) {
                console.error('Error al abrir la base de datos:', event.target.error);
            };
        };

        _this.getDataFromIndexedDB = function () {
            var dbName = '4GFlota-DDBB-Servicios';
            var storeName = 'jsonIOInfoTable';

            return new Promise(function (resolve, reject) {
                var request = indexedDB.open(dbName, 1);

                request.onupgradeneeded = function (event) {
                    var db = event.target.result;

                    if (!db.objectStoreNames.contains(storeName)) {
                        db.createObjectStore(storeName);
                    }
                };

                request.onsuccess = function (event) {
                    var db = event.target.result;

                    var transaction = db.transaction([storeName], 'readonly');
                    var objectStore = transaction.objectStore(storeName);
                    var getRequest = objectStore.get('jsonIOInfo');

                    getRequest.onsuccess = function () {
                        var data = getRequest.result;
                        resolve(data);
                    };

                    getRequest.onerror = function (event) {
                        reject(event.target.error);
                    };
                };

                request.onerror = function (event) {
                    reject(event.target.error);
                };
            });
        };

        _this.adaptState = function (values) {
            return values.map(function (value) {
                switch (value) {
                    case 0:
                        return { src: check0, state: "desactivado" };
                    case 1:
                        return { src: check1, state: "activado" };
                    case 2:
                        return { src: check2, state: "pendiente de activar" };
                    case 3:
                        return { src: check3, state: "pendiente de desactivar" };
                    default:
                        return { src: check0, state: "desactivado" };
                }
            });
        };

        _this.transformDate = function (ticks) {

            var epochTicks = 621355968000000000;
            var ticksPerMillisecond = 10000; // whoa!
            var maxDateMilliseconds = 8640000000000000; // via http://ecma-international.org/ecma-262/5.1/#sec-15.9.1.1
            var congratulationsTimer;
            var anHourTicks = 36000000000;

            if (_this.props.localTime !== undefined) {
                anHourTicks = anHourTicks * _this.props.localTime;
                ticks = ticks + anHourTicks;
            }

            var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

            if (isNaN(ticks)) {
                //      0001-01-01T00:00:00.000Z
                return "NANA-NA-NATNA:NA:BA.TMAN";
            }

            // convert the ticks into something javascript understands
            var ticksSinceEpoch = ticks - epochTicks;
            var millisecondsSinceEpoch = ticksSinceEpoch / ticksPerMillisecond;

            if (millisecondsSinceEpoch > maxDateMilliseconds) {
                //      +035210-09-17T07:18:31.111Z
                return "+WHOAWH-OA-ISTOO:FA:RA.WAYZ";
            }

            var date = new Date(millisecondsSinceEpoch);

            var seconds = date.getSeconds();
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            var day = date.getDate();
            if (day < 10) {
                day = "0" + day;
            }

            var month = date.getMonth();
            month = months[month];
            if (month < 10) {
                month = "0" + month;
            }

            var year = date.getFullYear();

            var hours = date.getUTCHours();

            var minutes = date.getUTCMinutes();

            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (hours < 10) {
                hours = "0" + hours;
            }

            var resultDate = day + "/" + month + "/" + year + " " + hours + ":" + minutes + ":" + seconds;
            return resultDate;
        };

        _this.transformDateAndCompare = function (ticks) {
            var bool = false;

            var hoy = new Date();
            var DIA_EN_MILISEGUNDOS = 24 * 60 * 60 * 1000;
            var ayer = new Date(hoy.getTime() - DIA_EN_MILISEGUNDOS);

            var epochTicks = 621355968000000000;
            var ticksPerMillisecond = 10000; // whoa!
            var maxDateMilliseconds = 8640000000000000; // via http://ecma-international.org/ecma-262/5.1/#sec-15.9.1.1
            var congratulationsTimer;
            var anHourTicks = 36000000000;

            if (_this.props.localTime !== undefined) {
                anHourTicks = anHourTicks * _this.props.localTime;
                ticks = ticks + anHourTicks;
            }

            if (isNaN(ticks)) {
                //      0001-01-01T00:00:00.000Z
                return "NANA-NA-NATNA:NA:BA.TMAN";
            }

            // convert the ticks into something javascript understands
            var ticksSinceEpoch = ticks - epochTicks;
            var millisecondsSinceEpoch = ticksSinceEpoch / ticksPerMillisecond;

            if (millisecondsSinceEpoch > maxDateMilliseconds) {
                //      +035210-09-17T07:18:31.111Z
                return "+WHOAWH-OA-ISTOO:FA:RA.WAYZ";
            }
            var newDate = new Date(millisecondsSinceEpoch);
            if (newDate <= ayer) {
                bool = true;
            } else {
                bool = false;
            }
            return bool;
        };

        _this.state = {
            profiles: [],
            userFromDataBase: '',
            value: '',
            isLoaded: false,
            markersV: [],
            groupsDevices: [],
            jsonGroups: [],
            jsonInfo: []

        };
        return _this;
    }

    _createClass(getProfiles, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // this.props.i18n.changeLanguage("fr");
            // console.log(this.props);
            document.getElementById("pin").style.display = "block";
            if (this.props.userDataInfo.email !== "") {
                this.getData();
            }

            this.getAssetsTags();
        }
    }, {
        key: 'getData',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var userData;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return API.graphql(graphqlOperation(getUsers, { email: this.props.userDataInfo.email }));

                            case 2:
                                userData = _context2.sent;

                                if (!(userData.data.getUsers === null)) {
                                    _context2.next = 8;
                                    break;
                                }

                                createProfile = true;
                                return _context2.abrupt('return');

                            case 8:
                                createProfile = false;

                            case 9:
                                userFromDataBase = Object.assign({}, userFromDataBase, { userData: userData });
                                this.getProfile();

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getData() {
                return _ref2.apply(this, arguments);
            }

            return getData;
        }()
    }, {
        key: 'getAssetsTags',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var _this3 = this;

                var responseGroups, groups, i, element;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return fetch(this.props.urlApi + 'AssetsTags', {
                                    headers: {
                                        'accessToken': this.props.accessToken
                                    }
                                });

                            case 2:
                                responseGroups = _context3.sent;
                                groups = [];

                                if (!responseGroups.ok) {
                                    _context3.next = 12;
                                    break;
                                }

                                _context3.next = 7;
                                return responseGroups.json();

                            case 7:
                                jsonGroups = _context3.sent;


                                for (i = 0; i < jsonGroups.length; i++) {
                                    element = jsonGroups[i];

                                    element = {
                                        assetsTagInfo: jsonGroups[i].assetsTagInfo,
                                        assetsTagName: jsonGroups[i].assetsTagName,
                                        assetsTagsId: jsonGroups[i].assetsTagsId,
                                        isChecked: true
                                    };
                                    groups.push(element);
                                }
                                localStorage.setItem("jsonGroups", JSON.stringify(groups));

                                _context3.next = 13;
                                break;

                            case 12:
                                // alert("HTTP-Error: " + responseGroups.status);
                                // window.location.replace("https://webapp.4gflota.com/#/ExpireKeyErr/");
                                this.goToPageErr();

                            case 13:
                                this.setState({
                                    jsonGroups: groups
                                }, function () {
                                    return _this3.getAssetsInfo();
                                });

                            case 14:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getAssetsTags() {
                return _ref3.apply(this, arguments);
            }

            return getAssetsTags;
        }()
    }, {
        key: 'getAssetsInfo',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                var _this4 = this;

                var responseInfo, assetsInfo, i, element;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return fetch(this.props.urlApi + 'AssetsInfo', {
                                    headers: {
                                        'accessToken': this.props.accessToken
                                    }
                                });

                            case 2:
                                responseInfo = _context4.sent;
                                assetsInfo = [];

                                if (!responseInfo.ok) {
                                    _context4.next = 12;
                                    break;
                                }

                                _context4.next = 7;
                                return responseInfo.json();

                            case 7:
                                jsonInfo = _context4.sent;

                                for (i = 0; i < jsonInfo.length; i++) {
                                    element = jsonInfo[i];

                                    element = {
                                        assetsIOTInfo: element.assetsIOTInfo,
                                        assetsInfoDriverName: element.assetsInfoDriverName,
                                        assetsInfoId: element.assetsInfoId,
                                        assetsInfoImei: element.assetsInfoImei,
                                        assetsInfoName: element.assetsInfoName,
                                        assetsInfoSerialNumber: element.assetsInfoSerialNumber,
                                        assetsTagsId: element.assetsTagsId,
                                        isChecked: true
                                    };
                                    assetsInfo.push(element);
                                }
                                localStorage.setItem("jsonInfo", JSON.stringify(assetsInfo));

                                _context4.next = 13;
                                break;

                            case 12:
                                // alert("HTTP-Error: " + responseInfo.status);
                                // window.location.replace("https://webapp.4gflota.com/#/ExpireKeyErr/");
                                this.goToPageErr();

                            case 13:
                                this.setState({
                                    jsonInfo: jsonInfo
                                }, function () {
                                    return _this4.getAssetsIOT("0");
                                });

                            case 14:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function getAssetsInfo() {
                return _ref4.apply(this, arguments);
            }

            return getAssetsInfo;
        }()
    }, {
        key: 'getAssetsIOT',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(firstTime) {
                var t, jsonIOTempInfo, test, responseIOInfo, jsonInfo, i, j, labelTemp, tag, result, res, input, textToBeSearch;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                t = this.props.t;
                                jsonIOTempInfo = "";
                                test = "";
                                _context5.next = 5;
                                return fetch(this.props.urlApi + 'AssetsIOTInfo', {
                                    headers: {
                                        'accessToken': this.props.accessToken,
                                        'timestamp': firstTime
                                    }
                                });

                            case 5:
                                responseIOInfo = _context5.sent;

                                if (!responseIOInfo.ok) {
                                    _context5.next = 12;
                                    break;
                                }

                                _context5.next = 9;
                                return responseIOInfo.json();

                            case 9:
                                jsonIOTempInfo = _context5.sent;
                                _context5.next = 13;
                                break;

                            case 12:
                                // alert("HTTP-Error: " + responseIOInfo.status);
                                // window.location.replace("https://webapp.4gflota.com/#/ExpireKeyErr/");
                                this.goToPageErr();

                            case 13:
                                jsonInfo = localStorage.getItem("jsonInfo");

                                jsonInfo = JSON.parse(jsonInfo);
                                if (jsonInfo === null) {
                                    jsonInfo = localStorage.getItem("jsonInfo");
                                    jsonInfo = JSON.parse(jsonInfo);
                                }
                                for (i = 0; i < this.state.jsonInfo.length; i++) {
                                    for (j = 0; j < jsonIOTempInfo.length; j++) {
                                        if (jsonInfo[i].assetsInfoImei === jsonIOTempInfo[j].assetsIOTImei.toString()) {
                                            labelTemp = "";
                                            tag = "";
                                            result = this.getBase4(jsonIOTempInfo[j].gOUTValue);
                                            res = this.adaptState(result);


                                            if (jsonIOTempInfo[j].tipoTrama === "ONM") {
                                                labelTemp = t("map.sidebar.filtersDevices.driving");
                                                tag = "Circulando";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "OFM") {
                                                labelTemp = t("map.sidebar.filtersDevices.driving");
                                                tag = "Circulando";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "ONS") {
                                                labelTemp = t("map.sidebar.filtersDevices.stop");
                                                tag = "Parado";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "OFS") {
                                                labelTemp = t("map.sidebar.filtersDevices.parked");
                                                tag = "Estacionado";
                                            }

                                            if (jsonIOTempInfo[j].tipoTrama === "OFGPRS") {
                                                labelTemp = t("map.sidebar.filtersDevices.noGprs");
                                                tag = "NoGprs";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "OFGPS") {
                                                labelTemp = "No GPS";
                                                tag = "NoGps";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "OFINS") {
                                                labelTemp = "Pendiente de instalación";
                                                tag = "NoInstalacion";
                                            }

                                            jsonIOTempInfo[j] = {
                                                assetsInfoName: jsonInfo[i].assetsInfoName,
                                                assetsIOTImei: jsonIOTempInfo[j].assetsIOTImei,
                                                label: labelTemp,
                                                tag: tag,
                                                id: jsonInfo[i].assetsInfoId,
                                                gpsInfo: {
                                                    altitude: jsonIOTempInfo[j].gpsInfo.altitude,
                                                    angle: jsonIOTempInfo[j].gpsInfo.angle,
                                                    latitude: jsonIOTempInfo[j].gpsInfo.latitude,
                                                    longitude: jsonIOTempInfo[j].gpsInfo.longitude,
                                                    sattellites: jsonIOTempInfo[j].gpsInfo.satellites,
                                                    speed: jsonIOTempInfo[j].gpsInfo.speed,
                                                    timestamp: this.transformDate(jsonIOTempInfo[j].gpsInfo.timestamp),
                                                    timestampApi: jsonIOTempInfo[j].gpsInfo.timestamp
                                                },
                                                canInfo: {
                                                    odometro: jsonIOTempInfo[j].canInfo.odo,
                                                    fuelPorcentage: jsonIOTempInfo[j].canInfo.flp,
                                                    fuelLiters: jsonIOTempInfo[j].canInfo.fll
                                                },
                                                temperatura: {
                                                    temp: jsonIOTempInfo[j].temp
                                                },
                                                gOUTValue: res,
                                                tipoTrama: jsonIOTempInfo[j].tipoTrama
                                            };
                                        }
                                    }
                                }
                                // console.log(jsonIOTempInfo);
                                if (firstTime === "0") {
                                    jsonIOInfo = jsonIOTempInfo;
                                    this.saveJsonIOInfo(jsonIOInfo);

                                    //localStorage.setItem("jsonIOInfo", JSON.stringify(jsonIOInfo));

                                }

                                input = document.getElementById("inputText");
                                textToBeSearch = "";

                                if (input !== null) textToBeSearch = input.value;

                                this.appliedMarkersVFilter();

                            case 22:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function getAssetsIOT(_x) {
                return _ref5.apply(this, arguments);
            }

            return getAssetsIOT;
        }()
    }, {
        key: 'getBase4',
        value: function getBase4(val) {
            var res = [0, 0, 0, 0];

            if (val <= 255) {
                if (val < 4) {
                    res[3] = val;
                } else {
                    var cociente = val;
                    var resAux = [0, 0, 0, 0];
                    var i = 0;

                    while (cociente >= 4) {
                        resAux[i] = cociente % 4;
                        cociente = Math.floor(cociente / 4);
                        i++;
                    }
                    resAux[i] = cociente;

                    switch (i) {
                        case 1:
                            res[2] = resAux[1];
                            res[3] = resAux[0];
                            break;
                        case 2:
                            res[1] = resAux[2];
                            res[2] = resAux[1];
                            res[3] = resAux[0];
                            break;
                        case 3:
                            res[0] = resAux[3];
                            res[1] = resAux[2];
                            res[2] = resAux[1];
                            res[3] = resAux[0];
                            break;
                    }
                }
            } else {
                res = [1, 1, 1, 1];
            }

            return res.reverse();
        }
    }, {
        key: 'appliedMarkersVFilter',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                var newArray, data, jsonTempInfo, i, j, jsonGroups, jsonTempGroup, _i, group, _j;

                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                newArray = [];
                                _context6.prev = 1;
                                _context6.next = 4;
                                return this.getDataFromIndexedDB();

                            case 4:
                                data = _context6.sent;

                                jsonIOInfo = data;
                                _context6.next = 11;
                                break;

                            case 8:
                                _context6.prev = 8;
                                _context6.t0 = _context6['catch'](1);

                                console.error('Error al obtener datos de IndexedDB:', _context6.t0);

                            case 11:

                                newArray = jsonIOInfo;

                                // Ordenar newArray por assetsInfoName
                                newArray.sort(function (a, b) {
                                    return (a.assetsInfoName || '').localeCompare(b.assetsInfoName || '');
                                });

                                jsonInfo = localStorage.getItem("jsonInfo");
                                jsonInfo = JSON.parse(jsonInfo);
                                jsonTempInfo = [];


                                for (i = 0; i < jsonInfo.length; i++) {
                                    for (j = 0; j < newArray.length; j++) {
                                        if (jsonInfo[i].assetsInfoImei === newArray[j].assetsIOTImei.toString()) {
                                            jsonInfo[i].assetsIOTInfo = [newArray[j]];
                                            jsonTempInfo.push(jsonInfo[i]);
                                        }
                                    }
                                }

                                // Ordenar jsonTempInfo por assetsInfoName
                                jsonTempInfo.sort(function (a, b) {
                                    return (a.assetsInfoName || '').localeCompare(b.assetsInfoName || '');
                                });

                                jsonGroups = localStorage.getItem("jsonGroups");

                                jsonGroups = JSON.parse(jsonGroups);
                                jsonTempGroup = [];


                                for (_i = 0; _i < this.state.jsonGroups.length; _i++) {
                                    group = jsonGroups[_i];

                                    group.assetsTagInfo = [];

                                    for (_j = 0; _j < jsonTempInfo.length; _j++) {
                                        if (group.assetsTagsId === jsonTempInfo[_j].assetsTagsId) {
                                            group.assetsTagInfo.push(jsonTempInfo[_j]);
                                        }
                                    }

                                    if (group.assetsTagInfo.length > 0) {
                                        // Ordenar assetsTagInfo dentro del grupo por assetsInfoName
                                        group.assetsTagInfo.sort(function (a, b) {
                                            return (a.assetsInfoName || '').localeCompare(b.assetsInfoName || '');
                                        });
                                        jsonTempGroup.push(group);
                                    }
                                }

                                // Ordenar jsonTempGroup por assetsTagsName
                                jsonTempGroup.sort(function (a, b) {
                                    return (a.assetsTagName || '').localeCompare(b.assetsTagName || '');
                                });

                                profiles = localStorage.getItem("profiles");
                                profiles = JSON.parse(profiles);
                                value = localStorage.getItem("value");
                                value = JSON.parse(value);

                                this.setState({
                                    groupsDevices: jsonTempGroup,
                                    markersV: newArray,
                                    isLoaded: true
                                });

                            case 28:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this, [[1, 8]]);
            }));

            function appliedMarkersVFilter() {
                return _ref6.apply(this, arguments);
            }

            return appliedMarkersVFilter;
        }()
    }, {
        key: 'render',
        value: function render() {
            // console.log("render getProfiles");

            return React.createElement(
                LoadScript,
                {
                    id: 'script-loader',
                    googleMapsApiKey: this.props.googleMapsApiKey,
                    loadingElement: React.createElement('div', null),
                    language: 'es-ES'
                    // googleMapsClientId={"gme-wirelesslogic"}
                    //googleMapsClientId={this.props.googleMapsClientId}
                },
                this.state.isLoaded && this.state.profiles !== null ? this.state.profiles[0] !== undefined ? React.createElement(Map, {
                    profiles: this.state.profiles,
                    value: this.state.value,
                    userDataInfo: this.props.userDataInfo,
                    urlApi: this.props.urlApi,
                    accessToken: this.props.accessToken,
                    markersV: this.state.markersV,
                    groupsDevices: this.state.groupsDevices,
                    localTime: this.props.localTime,
                    transformDateAndCompare: this.transformDateAndCompare,
                    propsRouter: this.props.propsRouter,
                    googleMapsApiKey: this.props.googleMapsApiKey
                    //origin={this.props.propsRouter.location.origin}
                    , origin: this.props.origin
                    // emailToProfile={this.props.propsRouter.location.emailToProfile}
                }) : null : null,
                this.state.isLoaded && this.state.profiles !== null ? this.state.profiles !== undefined ? this.state.profiles.length <= 0 ? React.createElement(Map, {
                    profiles: [],
                    value: "",
                    userDataInfo: this.props.userDataInfo,
                    urlApi: this.props.urlApi,
                    accessToken: this.props.accessToken,
                    markersV: this.state.markersV,
                    groupsDevices: this.state.groupsDevices,
                    localTime: this.props.localTime,
                    propsRouter: this.props.propsRouter,
                    googleMapsApiKey: this.props.googleMapsApiKey,
                    origin: this.props.origin
                    //origin={this.props.propsRouter.location.origin}
                    // emailToProfile={this.props.propsRouter.location.emailToProfile}
                }) : null : null : null
            );
        }
    }]);

    return getProfiles;
}(Component);

export default withTranslation()(getProfiles);